import React, { useEffect, useRef, useState } from "react";

export const TableHead = (props) => {
	const { columns, ThMouseClick, TheadRef, raz } = props;

	const [sensStates, setSensStates] = useState(
		Array(columns.length).fill(null)
	);

	const toggleState = (index) => {
		setSensStates((prevStates) => {
			let newStates = [...prevStates];
			newStates = newStates.map((state, key) =>
				key !== index ? null : !newStates[index]
			);
			ThMouseClick({
				slug: columns[index].slug,
				sens: newStates[index],
			});
			return newStates;
		});
	};

	const TheadRefContainer = useRef();

	useEffect(() => {
		if(TheadRef){
			TheadRef(TheadRefContainer.current);
		}
	}, []);
	useEffect(() => {
		if(raz===true){

			setSensStates((prevStates) => {
				let newStates = [...prevStates];
				newStates = newStates.map((state, key) =>
					newStates[key] = null
				);

				return newStates;
			});

		}
	},[raz]);
	return (
		<thead>
			<tr ref={TheadRefContainer}>
				{columns.map((column, key) => {
					return (
						<th key={key} >
							<div
								className={`head ${
									sensStates[key] === null
										? ""
										: sensStates[key]
										? "up"
										: "down"
								}`}
								onClick={() => {
									const slug = column.slug;
									toggleState(key);
								}}
							>
								<span className="icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 16 16"
									>
										<path
											fill="#000"
											d="M8.707.293a1 1 0 0 0-1.414 0L.929 6.657A1 1 0 0 0 2.343 8.07L8 2.414l5.657 5.657a1 1 0 1 0 1.414-1.414L8.707.293ZM7 1v15h2V1H7Z"
										/>
									</svg>
								</span>

								<span>{column.name}</span>
							</div>
						</th>
					);
				})}
			</tr>
		</thead>
	);
};
